export default __webpack_public_path__ + "static/media/856.3eb506cb.png";